import {
  NEXT_SHIPMENT_STEP,
  PREVIOUS_SHIPMENT_STEP,
  GO_TO_SHIPMENT_STEP,
  SET_SHIPMENT_FORM_PRISTINE,
  SET_AFTER_SUBMIT_ACTION,
  PROCESS_AFTER_SUBMIT_ACTION,
  SET_SHIPMENT_CARGO, SET_DELIVERY,
  SET_SHIPMENT, SET_FILES,
  SET_RECIPIENTS,
  SET_NOTIFICATION_CONTACTS,
  RESET_SHIPMENT_FORM_DATA,
  SET_SHIPMENT_FORM_STATUS,
  SET_JUST_SELECTED_TAB
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  step: 0,
  afterSubmitAction: null,
  pristine: {},
  shipment: {},
  delivery: [],
  cargo: [],
  notificationContacts: [],
  recipients: [],
  recipientFormItems: [],
  files: {
    filesToPost: [],
    filesToDelete: []
  },
  status: statuses.idle,
  justSelectedTab: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case NEXT_SHIPMENT_STEP:
      return { ...state, step: state.step + 1 };
    case PREVIOUS_SHIPMENT_STEP:
      return { ...state, step: state.step - 1 };
    case GO_TO_SHIPMENT_STEP:
      return { ...state, step: action.payload };
    case SET_SHIPMENT_FORM_PRISTINE:
      return {
        ...state,
        pristine: {
          ...state.pristine,
          [action.payload.form]: action.payload.value
        }
      };
    case SET_AFTER_SUBMIT_ACTION:
      return { ...state, afterSubmitAction: action.payload };
    case PROCESS_AFTER_SUBMIT_ACTION:
      return { ...state, afterSubmitAction: null, status: statuses.succeeded };
    case SET_SHIPMENT:
      return { ...state, shipment: action.payload };
    case SET_DELIVERY:
      return { ...state, delivery: action.payload };
    case SET_SHIPMENT_CARGO:
      return { ...state, cargo: action.payload };
    case SET_FILES:
      return { ...state, files: action.payload };
    case SET_RECIPIENTS:
      return {
        ...state,
        recipients: action.payload,
        recipientFormItems: action.formItems ?? state.recipientFormItems
      };
    case SET_NOTIFICATION_CONTACTS:
      return { ...state, notificationContacts: action.payload };
    case SET_SHIPMENT_FORM_STATUS:
      return { ...state, status: action.payload };
    case SET_JUST_SELECTED_TAB:
      return { ...state, justSelectedTab: action.payload };
    case RESET_SHIPMENT_FORM_DATA:
      return defaultState;
    default:
      return state;
  }
};
